import { SettlementDetailMain } from './components/containers';
import { COURIER_INVOICES_BASE_PATH } from '../constants';
import { Navigate, useParams } from 'react-router-dom';

export const CourierSettlementView = () => {
  const { id } = useParams<{ id: string }>();
  const settlementId = Number(id);

  if (!id || Number.isNaN(settlementId) || settlementId <= 0) {
    return <Navigate to={COURIER_INVOICES_BASE_PATH} replace />;
  }

  return <SettlementDetailMain settlementId={settlementId} />;
};
